
import { Router } from '@angular/router';
import { TokenStorage } from '../../core/token.storage';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthorizationService {
    
   

    constructor(private token: TokenStorage, private router: Router){}

    isClient() {

        if (this.token.getUserProfile() === 'CLIENT') {
                       
            this.router.navigate(['main']); 

       }
       
       
    }

    isAdmin() {
        if (this.token.getUserProfile() === 'ADMIN') {
           
            this.router.navigate(['admin/statistique']); 
            
           
       }
         
       
    }

}


// WEBPACK FOOTER //
// ./src/app/common/services/authorization.service.ts